import React from 'react';
import { withRouter } from 'react-router-dom';
import CorrigirMovimentacaoForm from './CorrigirMovimentacaoForm.jsx';
import CorrigirMovimentacaoConf from './CorrigirMovimentacaoConf.jsx';

class CorrigirMovimentacao extends React.Component {

    constructor() {

        super();

        this.state = {
            disabled: false,
            centro: "",
            centroId: 0,
            id: "",
            banco: "",
            bancos: [],
            data: "",
            historico: "",
            descricao: "",
            valor: "",
            notaFiscal: "",
            comprovante: "",
            analiseContabil: "",
            ghg: "",
            contaId: "",
            contas: [],
            vBanco: "",
            vData: "",
            vHistorico: "",
            vDescricao: "",
            vValor: "",
            vNotaFiscal: "",
            vComprovante: "",
            vAnaliseContabil: "",
            vGhg: "",
            vContaId: "",
            status: "",
            errBanco: 0,
            errData: 0,
            errHistorico: 0,
            errDescricao: 0,
            errValor: 0,
            errNotaFiscal: 0,
            errComprovante: 0,
            errAnaliseContabil: 0,
            errGhg: 0,
            errConta: 0,
            corrBanco: "",
            corrData: "",
            corrHistorico: "",
            corrDescricao: "",
            corrValor: "0,00",
            corrNotaFiscal: "",
            corrComprovante: "",
            corrAnaliseContabil: "",
            corrGhg: false,
            corrContaId: "",
            cadastradoPor: "",
            conta: "",
            codConta: "",
            codMovimentacao: "",
            corrConta: "",
            corrCodConta: "",
            corrCodMovimentacao: "",
            cadastradoPorNome: "",
            conf: false,
            edErrBanco: "",
            edErrData: "",
            edErrHistorico: "",
            edErrDescricao: "",
            edErrValor: "",
            edErrNotaFiscal: "",
            edErrComprovante: "",
            edErrAnaliseContabil: "",
            edErrGhg: "",
            edErrContaId: "",
            vErrBanco: "",
            vErrData: "",
            vErrHistorico: "",
            vErrDescricao: "",
            vErrValor: "",
            vErrNotaFiscal: "",
            vErrComprovante: "",
            vErrAnaliseContabil: "",
            vErrGhg: "",
            vErrContaId: "",
            filtroAno: "",
            filtroMes: "",
            vecMovPrev: null,
            vecMov: null
        };

        this.changeErrData = this.changeErrData.bind(this);
        this.changeErrBanco = this.changeErrBanco.bind(this);
        this.changeErrConta = this.changeErrConta.bind(this);
        this.changeErrHistorico = this.changeErrHistorico.bind(this);
        this.changeErrDescricao = this.changeErrDescricao.bind(this);
        this.changeErrValor = this.changeErrValor.bind(this);
        this.changeErrGhg = this.changeErrGhg.bind(this);
        this.changeErrNotaFiscal = this.changeErrNotaFiscal.bind(this);
        this.changeErrComprovante = this.changeErrComprovante.bind(this);
        this.changeErrAnaliseContabil = this.changeErrAnaliseContabil.bind(this);
        this.changeCorrData = this.changeCorrData.bind(this);
        this.changeCorrBanco = this.changeCorrBanco.bind(this);
        this.changeCorrConta = this.changeCorrConta.bind(this);
        this.changeCorrHistorico = this.changeCorrHistorico.bind(this);
        this.changeCorrDescricao = this.changeCorrDescricao.bind(this);
        this.changeCorrValor = this.changeCorrValor.bind(this);
        this.changeCorrGhg = this.changeCorrGhg.bind(this);
        this.changeCorrNotaFiscal = this.changeCorrNotaFiscal.bind(this);
        this.changeCorrComprovante = this.changeCorrComprovante.bind(this);
        this.changeCorrAnaliseContabil = this.changeCorrAnaliseContabil.bind(this);
        this.corrigir = this.corrigir.bind(this);
        this.cancelar = this.cancelar.bind(this);
        this.voltar = this.voltar.bind(this);
        this.confirmar = this.confirmar.bind(this);

    }

    moneyMask(str_val) {

        let res = ""; 
        let vec = str_val.split(".");
        let c = 0;

        for (let i = vec[0].length - 1; i >= 0; i--) {

            if (c !== 0 && c % 3 === 0 && vec[0][i] !== "-") {
                res = vec[0][i] + "." + res;
            } else {
                res = vec[0][i] + res;
            }   

            c++;

        }   

        if (vec[1] !== undefined) res = res + "," + vec[1];
        else res = res + ",00";

        return res;

    }

    moneyUnmask(str_val) {

        let res = "";
        let vec = str_val.split(",");

        for (let i = 0; i < vec[0].length; i++) {

            if (vec[0][i] !== ".") {
                res = res + vec[0][i];
            }

        }

        res = res + "." + vec[1];
        return res;

    }

    desformatarValor(s) {
        if (s === null) return "";
        return this.moneyUnmask(s);
    }

    formatarValor(s) {
        if (s === null) return "";
        return this.moneyMask(s);
    }

    changeErrData(e) {

        if (e.target.value === "1") this.setState({ errData: 1 });
        else if (e.target.value === "2") this.setState({ errData: 2 });
        else {

            if (this.state.edErrData === 3) this.setState({ errData: 3 });
            else this.setState({ errData: 0 });

            this.setState({ corrData: "" });

            if (this.state.corrConta !== "") {
                let vec = this.state.data.split("-");
                this.setState({ corrCodMovimentacao: this.state.corrCodConta + "-" + vec[1] });
            }

        }

    }

    changeErrBanco(e) {

        if (e.target.value === "1") this.setState({ errBanco: 1 });
        else if (e.target.value === "2") this.setState({ errBanco: 2 });
        else {

            if (this.state.edErrBanco === 3) this.setState({ errBanco: 3 });
            else this.setState({ errBanco: 0 });

            this.setState({ corrBanco: "" });

        }

    }

    changeErrConta(e) {

        if (e.target.value === "1") this.setState({ errConta: 1 });
        else if (e.target.value === "2") this.setState({ errConta: 2 });
        else {

            if (this.state.edErrContaId === 3) this.setState({ errConta: 3 });
            else this.setState({ errConta: 0 });

            this.setState({ corrConta: "" });
            this.setState({ corrCodConta: "" });
            this.setState({ corrCodMovimentacao: "" });

        }

    }

    changeErrHistorico(e) {

        if (e.target.value === "1") this.setState({ errHistorico: 1 });
        else if (e.target.value === "2") this.setState({ errHistorico: 2 });
        else {

            if (this.state.edErrHistorico === 3) this.setState({ errHistorico: 3 });
            else this.setState({ errHistorico: 0 });

            this.setState({ corrHistorico: "" });

        }

    }

    changeErrDescricao(e) {

        if (e.target.value === "1") this.setState({ errDescricao: 1 });
        else if (e.target.value === "2") this.setState({ errDescricao: 2 });
        else {

            if (this.state.edErrDescricao === 3) this.setState({ errDescricao: 3 });
            else this.setState({ errDescricao: 0 });

            this.setState({ corrDescricao: "" });

        }

    }

    changeErrValor(e) {

        if (e.target.value === "1") this.setState({ errValor: 1 });
        else if (e.target.value === "2") this.setState({ errValor: 2 });
        else {

            if (this.state.edErrValor === 3) this.setState({ errValor: 3 });
            else this.setState({ errValor: 0 });

            this.setState({ corrValor: "0,00" });

        }

    }

    changeErrGhg(e) {

        if (e.target.value === "1") this.setState({ errGhg: 1 });
        else if (e.target.value === "2") this.setState({ errGhg: 2 });
        else {

            if (this.state.edErrGhg === 3) this.setState({ errGhg: 3 });
            else this.setState({ errGhg: 0 });

            this.setState({ corrGhg: false });

        }

    }

    changeErrNotaFiscal(e) {

        if (e.target.value === "1") this.setState({ errNotaFiscal: 1 });
        else if (e.target.value === "2") this.setState({ errNotaFiscal: 2 });
        else {

            if (this.state.edErrNotaFiscal === 3) this.setState({ errNotaFiscal: 3 });
            else this.setState({ errNotaFiscal: 0 });

            this.setState({ corrNotaFiscal: "" });

        }

    }

    changeErrComprovante(e) {

        if (e.target.value === "1") this.setState({ errComprovante: 1 });
        else if (e.target.value === "2") this.setState({ errComprovante: 2 });
        else {

            if (this.state.edErrComprovante === 3) this.setState({ errComprovante: 3 });
            else this.setState({ errComprovante: 0 });

            this.setState({ corrComprovante: "" });

        }

    }

    changeErrAnaliseContabil(e) {

        if (e.target.value === "1") this.setState({ errAnaliseContabil: 1 });
        else if (e.target.value === "2") this.setState({ errAnaliseContabil: 2 });
        else {

            if (this.state.edErrAnaliseContabil === 3) this.setState({ errAnaliseContabil: 3 });
            else this.setState({ errAnaliseContabil: 0 });

            this.setState({ corrAnaliseContabil: "" });

        }

    }

    changeCorrData(e) {

        let i = e.target.value;

        if (i !== "" && this.state.corrConta !== "") {

            let vec = i.split("-");
            this.setState({ corrData: i });
            this.setState({ corrCodMovimentacao: this.state.corrCodConta + "-" + vec[1] });

        } else if (i !== "" && this.state.corrConta === "") {

            this.setState({ corrData: i });
            this.setState({ corrCodMovimentacao: "" });

        } else {

            this.setState({ corrData: i });
            this.setState({ corrCodMovimentacao: "" });

        }

    }

    changeCorrBanco(e) {
        this.setState({ corrBanco: e.target.value });
    }

    changeCorrConta(e) {

        let i = e.target.value;

        if (i !== "" && this.state.corrData !== "") {

            let vec = this.state.corrData.split("-");
            this.setState({ corrConta: i });
            this.setState({ corrCodConta: this.state.contas[i].cod_conta });
            this.setState({ corrCodMovimentacao: this.state.contas[i].cod_conta + "-" + vec[1] });

        } else if (i !== "" && this.state.corrData === "") {

            let vec = this.state.vData.split("-");
            this.setState({ corrConta: i });
            this.setState({ corrCodConta: this.state.contas[i].cod_conta });
            this.setState({ corrCodMovimentacao: this.state.contas[i].cod_conta + "-" + vec[1] });

        } else {

            this.setState({ corrConta: "" });
            this.setState({ corrCodConta: "" });
            this.setState({ corrCodMovimentacao: "" });

        }

    }

    changeCorrHistorico(e) {
        this.setState({ corrHistorico: e.target.value });
    }

    changeCorrDescricao(e) {
        this.setState({ corrDescricao: e.target.value });
    }

    changeCorrValor(e) {

        let sval = "";
        let re = /^(-|[0-9])$/i;
        let neg = false;

        if (e.target.value !== "-0,0") {

            for (let i = 0; i < e.target.value.length; i++) {

                if (re.test(e.target.value[i])) {

                    if (e.target.value[i] === "-") neg = true;
                    else sval = sval + e.target.value[i];

                }

            }

        }

        sval = parseInt(sval);
        sval = sval.toString();
        let res = "";

        if (sval === "NaN") {

            res = "0,00";

        } else if (sval.length === 1) {

            res = "0,0" + sval;

        } else if (sval.length === 2) {

            res = "0," + sval;

        } else {

            let i = sval.length - 1;
            let c = 0;

            res = sval[i] + res;
            i--;

            res = sval[i] + res;
            i--;

            res = "," + res;

            for (; i >= 0; i--) {

                if (c !== 0 && c % 3 === 0) {
                    res = sval[i] + "." + res;
                } else {
                    res = sval[i] + res;
                }

                c++;

            }

        }

        if (neg) {
            res = "-" + res;
        }

        this.setState({ corrValor: res });

    }

    changeCorrGhg(e) {
        if (e.target.value === "true") this.setState({ corrGhg: true });
        else this.setState({ corrGhg: false });
    }

    changeCorrNotaFiscal(e) {
        e.preventDefault();
        this.setState({ corrNotaFiscal: e.target.files[0] });
    }

    changeCorrComprovante(e) {
        e.preventDefault();
        this.setState({ corrComprovante: e.target.files[0] });
    }

    changeCorrAnaliseContabil(e) {
        this.setState({ corrAnaliseContabil: e.target.value });
    }

    corrigir() {

        let re = /^.{1,}\.(pdf|xml|jpg|jpeg|png)$/i;

        if ((this.state.errData !== 0 && this.state.errData !== 3)
            && this.state.corrData === "") {

            this.props.errMsgHandler("Por favor, informe a data corrigida.");

        } else if ((this.state.errBanco !== 0 && this.state.errBanco !== 3)
            && this.state.corrBanco === "") {

            this.props.errMsgHandler("Por favor, informe o banco corrigido.");

        } else if ((this.state.errConta !== 0 && this.state.errConta !== 3)
            && this.state.corrConta === "") {

            this.props.errMsgHandler("Por favor, informe a conta corrigida.");

        } else if ((this.state.errHistorico !== 0 && this.state.errHistorico !== 3)
            && this.state.corrHistorico === "") {

            this.props.errMsgHandler("Por favor, informe o histórico da movientação corrigido.");

        } else if ((this.state.errDescricao !== 0 && this.state.errDescricao !== 3)
            && this.state.corrDescricao === "") {

            this.props.errMsgHandler("Por favor, informe a descrição da movimentação corrigida.");

        } else if ((this.state.errValor !== 0 && this.state.errValor !== 3)
            && (this.state.corrValor === "0,00" || this.state.corrValor === "-0,00")) {

            this.props.errMsgHandler("Por favor, informe o valor da movimentação corrigido.");

        } else if ((this.state.errNotaFiscal !== 0 && this.state.errNotaFiscal !== 3)
            && this.state.corrNotaFiscal !== "" && this.state.corrNotaFiscal !== null
            && !re.test(this.state.corrNotaFiscal.name)) {

            this.props.errMsgHandler("É permitido somente o anexo de arquivos PDF, XML, JPG e PNG.");

        } else if ((this.state.errComprovante !== 0 && this.state.errComprovante !== 3)
            && this.state.corrComprovante !== "" && this.state.corrComprovante !== null
            && !re.test(this.state.corrComprovante.name)) {

            this.props.errMsgHandler("É permitido somente o anexo de arquivos PDF, XML, JPG e PNG.");

        } else if ((this.state.errAnaliseContabil !== 0 && this.state.errAnaliseContabil !== 3)
            && this.state.corrAnaliseContabil === "") {

            this.props.errMsgHandler("Por favor, informe a análise contábil corrigida.");

        } else {

            this.props.errMsgHandler("");

            if (this.state.errBanco !== 0 && this.state.status === 0) this.setState({ vErrBanco: this.state.errBanco });
            else if (this.state.errBanco !== 0 && this.state.status !== 0) this.setState({ vErrBanco: 4 });
            else if (this.state.edErrBanco === null) this.setState({ vErrBanco: 0 });
            else this.setState({ vErrBanco: this.state.edErrBanco });

            if (this.state.errData !== 0 && this.state.status === 0) this.setState({ vErrData: this.state.errData });
            else if (this.state.errData !== 0 && this.state.status !== 0) this.setState({ vErrData: 4 });
            else if (this.state.edErrData === null) this.setState({ vErrData: 0 });
            else this.setState({ vErrData: this.state.edErrData });

            if (this.state.errHistorico !== 0 && this.state.status === 0) this.setState({ vErrHistorico: this.state.errHistorico });
            else if (this.state.errHistorico !== 0 && this.state.status !== 0) this.setState({ vErrHistorico: 4 });
            else if (this.state.edErrHistorico === null) this.setState({ vErrHistorico: 0 });
            else this.setState({ vErrHistorico: this.state.edErrHistorico });

            if (this.state.errDescricao !== 0 && this.state.status === 0) this.setState({ vErrDescricao: this.state.errDescricao });
            else if (this.state.errDescricao !== 0 && this.state.status !== 0) this.setState({ vErrDescricao: 4 });
            else if (this.state.edErrDescricao === null) this.setState({ vErrDescricao: 0 });
            else this.setState({ vErrDescricao: this.state.edErrDescricao });

            if (this.state.errValor !== 0 && this.state.status === 0) this.setState({ vErrValor: this.state.errValor });
            else if (this.state.errValor !== 0 && this.state.status !== 0) this.setState({ vErrValor: 4 });
            else if (this.state.edErrValor === null) this.setState({ vErrValor: 0 });
            else this.setState({ vErrValor: this.state.edErrValor });

            if (this.state.errNotaFiscal !== 0 && this.state.status === 0) this.setState({ vErrNotaFiscal: this.state.errNotaFiscal });
            else if (this.state.errNotaFiscal !== 0 && this.state.status !== 0) this.setState({ vErrNotaFiscal: 4 });
            else if (this.state.edErrNotaFiscal === null) this.setState({ vErrNotaFiscal: 0 });
            else this.setState({ vErrNotaFiscal: this.state.edErrNotaFiscal });

            if (this.state.errComprovante !== 0 && this.state.status === 0) this.setState({ vErrComprovante: this.state.errComprovante });
            else if (this.state.errComprovante !== 0 && this.state.status !== 0) this.setState({ vErrComprovante: 4 });
            else if (this.state.edErrComprovante === null) this.setState({ vErrComprovante: 0 });
            else this.setState({ vErrComprovante: this.state.edErrComprovante });

            if (this.state.errAnaliseContabil !== 0 && this.state.status === 0) this.setState({ vErrAnaliseContabil: this.state.errAnaliseContabil });
            else if (this.state.errAnaliseContabil !== 0 && this.state.status !== 0) this.setState({ vErrAnaliseContabil: 4 });
            else if (this.state.edErrAnaliseContabil === null) this.setState({ vErrAnaliseContabil: 0 });
            else this.setState({ vErrAnaliseContabil: this.state.edErrAnaliseContabil });

            if (this.state.errGhg !== 0 && this.state.status === 0) this.setState({ vErrGhg: this.state.errGhg });
            else if (this.state.errGhg !== 0 && this.state.status !== 0) this.setState({ vErrGhg: 4 });
            else if (this.state.edErrGhg === null) this.setState({ vErrGhg: 0 });
            else this.setState({ vErrGhg: this.state.edErrGhg });

            if (this.state.errConta !== 0 && this.state.status === 0) this.setState({ vErrContaId: this.state.errConta });
            else if (this.state.errConta !== 0 && this.state.status !== 0) this.setState({ vErrContaId: 4 });
            else if (this.state.edErrContaId === null) this.setState({ vErrContaId: 0 });
            else this.setState({ vErrContaId: this.state.edErrContaId });

            this.setState({ conf: true });

        }

    }

    cancelar() {

        let obj = {
            row: {
                id: this.state.id,
                data: []
            },
            filtroAno: this.state.filtroAno,
            filtroMes: this.state.filtroMes,
            vecMovPrev: this.state.vecMovPrev,
            vecMov: this.state.vecMov
        };

        this.props.history.push({
            pathname: "/visualizarmovimentacao",
            state: obj
        });

    }

    voltar() {

        this.setState({ conf: false });

        this.setState({ vErrBanco: "" });
        this.setState({ vErrData: "" });
        this.setState({ vErrHistorico: "" });
        this.setState({ vErrDescricao: "" });
        this.setState({ vErrValor: "" });
        this.setState({ vErrNotaFiscal: "" });
        this.setState({ vErrComprovante: "" });
        this.setState({ vErrAnaliseContabil: "" });
        this.setState({ vErrGhg: "" });
        this.setState({ vErrConta: "" });

    }

    confirmar() {

        this.setState({ disabled: true });
        this.props.waitMsgHandler("Aguardando");

        if (this.state.errData === 0 && this.state.errBanco === 0 && this.state.errConta === 0
            && this.state.errHistorico === 0 && this.state.errDescricao === 0 && this.state.errValor === 0
            && this.state.errGhg === 0 && this.state.errNotaFiscal === 0 && this.state.errComprovante === 0
            && this.state.errAnaliseContabil === 0 && this.state.status === 0) {

            let obj = {
                "_id": this.state.id
            };

            fetch("/api/movimentacao/aprovar", {
                method: "PUT",
                headers: {
                    "Content-type": "application/json",
                    "Authorization": "Basic " + btoa(localStorage.auth)
                },
                mode: "cors",
                body: JSON.stringify(obj)
            })
            .then(response => response.json())
            .then(responseJson => {

                if (responseJson.msg === "success") {

                    this.props.waitMsgHandler("");
                    this.props.successMsgHandler("Movimentação financeira corrigida com sucesso.");

                    let vecMovPrev = this.state.vecMovPrev;
                    let vecMov = this.state.vecMov;

                    if (vecMov.length > 1) {
                        vecMovPrev.push(vecMov.shift());
                    }

                    let obj2 = {
                        row: {
                            id: vecMov[0].id,
                            data: []
                        },
                        filtroAno: this.state.filtroAno,
                        filtroMes: this.state.filtroMes,
                        vecMovPrev: vecMovPrev,
                        vecMov: vecMov
                    };

                    if (vecMov.length !== 0) obj2.row.id = vecMov[0].id;

                    this.props.history.push({
                        pathname: "/visualizarmovimentacao",
                        state: obj2
                    });

                }

            });

        } else {

            let statusCode = 3;

            let errVec = [
                this.state.errData, this.state.errBanco, this.state.errConta,
                this.state.errHistorico, this.state.errDescricao, this.state.errValor,
                this.state.errGhg, this.state.errNotaFiscal, this.state.errComprovante,
                this.state.errAnaliseContabil
            ];

            if (errVec.find((x) => { return x === 2 }) !== undefined) statusCode = 2;

            let obj = {
                "_id": this.state.id,
                "banco": this.state.banco,
                "data": this.state.data,
                "historico": this.state.historico,
                "descricao": this.state.descricao,
                "valor": this.state.valor,
                "nota_fiscal": this.state.notaFiscal,
                "comprovante": this.state.comprovante,
                "analise_contabil": this.state.analiseContabil,
                "ghg": this.state.ghg,
                "conta_id": this.state.contaId,
                "status": statusCode,
                "err_data": null,
                "err_banco": null,
                "err_conta_id": null,
                "err_historico": null,
                "err_descricao": null,
                "err_valor": null,
                "err_ghg": null,
                "err_nota_fiscal": null,
                "err_comprovante": null,
                "err_analise_contabil": null,
                "corr_data": null,
                "corr_banco": null,
                "corr_conta_id": null,
                "corr_historico": null,
                "corr_descricao": null,
                "corr_valor": null,
                "corr_ghg": null,
                "corr_nota_fiscal": "",
                "corr_comprovante": "",
                "corr_analise_contabil": null,
                "cadastrado_por": this.state.cadastradoPor,
                "corrigido_por": JSON.parse(localStorage.usuarioInfo).id
            };

            if ((this.state.status !== 0 && this.state.errData !== 0 && this.state.errData !== 3) || this.state.edErrData === 4) {
                obj.err_data = 4;
            } else if (this.state.status !== 0 && (this.state.errData === 0 || this.state.errData === 3)) {
                obj.err_data = this.state.edErrData;
                obj.status = 2;
            } else {
                obj.err_data = this.state.errData;
            }

            if ((this.state.status !== 0 && this.state.errBanco !== 0 && this.state.errBanco !== 3) || this.state.edErrBanco === 4) {
                obj.err_banco = 4;
            } else if (this.state.status !== 0 && (this.state.errBanco === 0 || this.state.errBanco === 3)) {
                obj.err_banco = this.state.edErrBanco;
                obj.status = 2;
            } else {
                obj.err_banco = this.state.errBanco;
            }

            if ((this.state.status !== 0 && this.state.errConta !== 0 && this.state.errConta !== 3) || this.state.edErrContaId === 4) {
                obj.err_conta_id = 4;
            } else if (this.state.status !== 0 && (this.state.errConta === 0 || this.state.errConta === 3)) {
                obj.err_conta_id = this.state.edErrContaId;
                obj.status = 2;
            } else {
                obj.err_conta_id = this.state.errConta;
            }

            if ((this.state.status !== 0 && this.state.errHistorico !== 0 && this.state.errHistorico !== 3) || this.state.edErrHistorico === 4) {
                obj.err_historico = 4;
            } else if (this.state.status !== 0 && (this.state.errHistorico === 0 || this.state.errHistorico === 3)) {
                obj.err_historico = this.state.edErrHistorico;
                obj.status = 2;
            } else {
                obj.err_historico = this.state.errHistorico;
            }

            if ((this.state.status !== 0 && this.state.errDescricao !== 0 && this.state.errDescricao !== 3) || this.state.edErrDescricao === 4) {
                obj.err_descricao = 4;
            } else if (this.state.status !== 0 && (this.state.errDescricao === 0 || this.state.errDescricao === 3)) {
                obj.err_descricao = this.state.edErrDescricao;
                obj.status = 2;
            } else {
                obj.err_descricao = this.state.errDescricao;
            }

            if ((this.state.status !== 0 && this.state.errValor !== 0 && this.state.errValor !== 3) || this.state.edErrValor === 4) {
                obj.err_valor = 4;
            } else if (this.state.status !== 0 && (this.state.errValor === 0 || this.state.errValor === 3)) {
                obj.err_valor = this.state.edErrValor;
                obj.status = 2;
            } else {
                obj.err_valor = this.state.errValor;
            }

            if ((this.state.status !== 0 && this.state.errGhg !== 0 && this.state.errGhg !== 3) || this.state.edErrGhg === 4) {
                obj.err_ghg = 4;
            } else if (this.state.status !== 0 && (this.state.errGhg === 0 || this.state.errGhg === 3)) {
                obj.err_ghg = this.state.edErrGhg;
                obj.status = 2;
            } else {
                obj.err_ghg = this.state.errGhg;
            }

            if ((this.state.status !== 0 && this.state.errNotaFiscal !== 0 && this.state.errNotaFiscal !== 3) || this.state.edErrNotaFiscal === 4) {
                obj.err_nota_fiscal = 4;
            } else if (this.state.status !== 0 && (this.state.errNotaFiscal === 0 || this.state.errNotaFiscal === 3)) {
                obj.err_nota_fiscal = this.state.edErrNotaFiscal;
                obj.status = 2;
            } else {
                obj.err_nota_fiscal = this.state.errNotaFiscal;
            }

            if ((this.state.status !== 0 && this.state.errComprovante !== 0 && this.state.errComprovante !== 3) || this.state.edErrComprovante === 4) {
                obj.err_comprovante = 4;
            } else if (this.state.status !== 0 && (this.state.errComprovante === 0 || this.state.errComprovante === 3)) {
                obj.err_comprovante = this.state.edErrComprovante;
                obj.status = 2;
            } else {
                obj.err_comprovante = this.state.errComprovante;
            }

            if ((this.state.status !== 0 && this.state.errAnaliseContabil !== 0 && this.state.errAnaliseContabil !== 3) || this.state.edErrAnaliseContabil === 4) {
                obj.err_analise_contabil = 4;
            } else if (this.state.status !== 0 && (this.state.errAnaliseContabil === 0 || this.state.errAnaliseContabil === 3)) {
                obj.err_analise_contabil = this.state.edErrAnaliseContabil;
                obj.status = 2;
            } else {
                obj.err_analise_contabil = this.state.errAnaliseContabil;
            }

            if (this.state.errData !== 0 && this.state.errData !== 3) {
                obj.corr_data = this.state.corrData;
            } else if (this.state.edErrData !== 0 && this.state.edErrData !== 3 && this.state.edErrData !== null) {
                obj.corr_data = this.state.vData;
            }

            if (this.state.errBanco !== 0 && this.state.errBanco !== 3) {
                obj.corr_banco = this.state.corrBanco;
            } else if (this.state.edErrBanco !== 0 && this.state.edErrBanco !== 3 && this.state.edErrBanco !== null) {
                obj.corr_banco = this.state.vBanco;
            }

            if (this.state.errConta !== 0 && this.state.errConta !== 3) {
                obj.corr_conta_id = this.state.contas[this.state.corrConta].id;
            } else if (this.state.edErrContaId !== 0 && this.state.edErrContaId !== 3 && this.state.edErrContaId !== null) {
                obj.corr_conta_id = this.state.vContaId;
            }

            if (this.state.errHistorico !== 0 && this.state.errHistorico !== 3) {
                obj.corr_historico = this.state.corrHistorico;
            } else if (this.state.edErrHistorico !== 0 && this.state.edErrHistorico !== 3 && this.state.edErrHistorico !== null) {
                obj.corr_historico = this.state.vHistorico;
            }

            if (this.state.errDescricao !== 0 && this.state.errDescricao !== 3) {
                obj.corr_descricao = this.state.corrDescricao;
            } else if (this.state.edErrDescricao !== 0 && this.state.edErrDescricao !== 3 && this.state.edErrDescricao !== null) {
                obj.corr_descricao = this.state.vDescricao;
            }

            if (this.state.errValor !== 0 && this.state.errValor !== 3) {
                obj.corr_valor = this.desformatarValor(this.state.corrValor);
            } else if (this.state.edErrValor !== 0 && this.state.edErrValor !== 3 && this.state.edErrValor !== null) {
                obj.corr_valor = this.state.vValor;
            }

            if (this.state.errGhg !== 0 && this.state.errGhg !== 3) {
                obj.corr_ghg = this.state.corrGhg;
            } else if (this.state.edErrGhg !== 0 && this.state.edErrGhg !== 3 && this.state.edErrGhg !== null) {
                obj.corr_ghg = this.state.vGhg;
            }

            if (this.state.errAnaliseContabil !== 0 && this.state.errAnaliseContabil !== 3) {
                obj.corr_analise_contabil = this.state.corrAnaliseContabil;
            } else if (this.state.edErrAnaliseContabil !== 0 && this.state.edErrAnaliseContabil !== 3 && this.state.edErrAnaliseContabil !== null) {
                obj.corr_analise_contabil = this.state.vAnaliseContabil;
            }

            let formData1 = new FormData();

            if (this.state.errNotaFiscal !== 0 && this.state.errNotaFiscal !== 3
                && this.state.corrNotaFiscal !== "") {

                obj.corr_nota_fiscal = this.state.corrNotaFiscal.name;
                formData1.append('file', this.state.corrNotaFiscal);

            } else if (this.state.errNotaFiscal !== 0 && this.state.errNotaFiscal !== 3
                && this.state.corrNotaFiscal === "") {

                obj.corr_nota_fiscal = null;

            } else if (this.state.edErrNotaFiscal !== 0 && this.state.edErrNotaFiscal !== 3 && this.state.edErrNotaFiscal !== null) {
                obj.corr_nota_fiscal = this.state.vNotaFiscal;
            }

            let formData2 = new FormData();

            if (this.state.errComprovante !== 0 && this.state.errComprovante !== 3
                && this.state.corrComprovante !== "") {

                obj.corr_comprovante = this.state.corrComprovante.name;
                formData2.append('file', this.state.corrComprovante);

            } else if (this.state.errComprovante !== 0 && this.state.errComprovante !== 3
                && this.state.corrComprovante === "") {

                obj.corr_comprovante = null;

            } else if (this.state.edErrComprovante !== 0 && this.state.edErrComprovante !== 3 && this.state.edErrComprovante !== null) {
                obj.corr_comprovante = this.state.vComprovante;
            }

            fetch("/api/movimentacao/", {
                method: "PUT",
                headers: {
                    "Content-type": "application/json",
                    "Authorization": "Basic " + btoa(localStorage.auth)
                },
                mode: "cors",
                body: JSON.stringify(obj)
            })
            .then(response => response.json())
            .then(responseJson => {

                if (responseJson.msg === "success") {

                    if (((this.state.errNotaFiscal === 0 || this.state.errNotaFiscal === 3)
                        && (this.state.errComprovante === 0 || this.state.errComprovante === 3))
                        || (this.state.corrNotaFiscal === "" && this.state.corrComprovante === "")) {

                        this.props.waitMsgHandler("");
                        this.props.successMsgHandler("Movimentação financeira corrigida com sucesso.");

                        let vecMovPrev = this.state.vecMovPrev;
                        let vecMov = this.state.vecMov;

                        if (vecMov.length > 1) {
                            vecMovPrev.push(vecMov.shift());
                        }

                        let obj2 = {
                            row: {
                                id: vecMov[0].id,
                                data: []
                            },
                            filtroAno: this.state.filtroAno,
                            filtroMes: this.state.filtroMes,
                            vecMovPrev: vecMovPrev,
                            vecMov: vecMov
                        };

                        if (vecMov.length !== 0) obj2.row.id = vecMov[0].id;

                        this.props.history.push({
                            pathname: "/visualizarmovimentacao",
                            state: obj2
                        });

                    } else if ((this.state.errNotaFiscal !== 0 && this.state.errNotaFiscal !== 3)
                        && (this.state.errComprovante === 0 || this.state.errComprovante === 3)
                        && this.state.corrNotaFiscal !== "") {

                        fetch("/api/movimentacao/upload/corrnf/" + this.state.id, {
                            method: "POST",
                            headers: {
                                "Authorization": "Basic " + btoa(localStorage.auth)
                            },
                            mode: "cors",
                            body: formData1
                        })
                        .then(response2 => response2.json())
                        .then(responseJson2 => {

                            if (responseJson2.msg === "success") {

                                this.props.waitMsgHandler("");
                                this.props.successMsgHandler("Movimentação financeira corrigida com sucesso.");

                                let vecMovPrev = this.state.vecMovPrev;
                                let vecMov = this.state.vecMov;

                                if (vecMov.length > 1) {
                                    vecMovPrev.push(vecMov.shift());
                                }

                                let obj2 = {
                                    row: {
                                        id: vecMov[0].id,
                                        data: []
                                    },
                                    filtroAno: this.state.filtroAno,
                                    filtroMes: this.state.filtroMes,
                                    vecMovPrev: vecMovPrev,
                                    vecMov: vecMov
                                };

                                if (vecMov.length !== 0) obj2.row.id = vecMov[0].id;

                                this.props.history.push({
                                    pathname: "/visualizarmovimentacao",
                                    state: obj2
                                });

                            }

                        });

                    } else if ((this.state.errNotaFiscal === 0 || this.state.errNotaFiscal === 3)
                        && (this.state.errComprovante !== 0 && this.state.errComprovante !== 3)
                        && this.state.corrComprovante !== "") {

                        fetch("/api/movimentacao/upload/corrcp/" + this.state.id, {
                            method: "POST",
                            headers: {
                                "Authorization": "Basic " + btoa(localStorage.auth)
                            },
                            mode: "cors",
                            body: formData2
                        })
                        .then(response2 => response2.json())
                        .then(responseJson2 => {

                            if (responseJson2.msg === "success") {

                                this.props.waitMsgHandler("");
                                this.props.successMsgHandler("Movimentação financeira corrigida com sucesso.");

                                let vecMovPrev = this.state.vecMovPrev;
                                let vecMov = this.state.vecMov;

                                if (vecMov.length > 1) {
                                    vecMovPrev.push(vecMov.shift());
                                }

                                let obj2 = {
                                    row: {
                                        id: vecMov[0].id,
                                        data: []
                                    },
                                    filtroAno: this.state.filtroAno,
                                    filtroMes: this.state.filtroMes,
                                    vecMovPrev: vecMovPrev,
                                    vecMov: vecMov
                                };

                                if (vecMov.length !== 0) obj2.row.id = vecMov[0].id;

                                this.props.history.push({
                                    pathname: "/visualizarmovimentacao",
                                    state: obj2
                                });

                            }

                        });

                    } else {

                        fetch("/api/movimentacao/upload/corrnf/" + this.state.id, {
                            method: "POST",
                            headers: {
                                "Authorization": "Basic " + btoa(localStorage.auth)
                            },
                            mode: "cors",
                            body: formData1
                        })
                        .then(response2 => response2.json())
                        .then(responseJson2 => {

                            if (responseJson2.msg === "success") {

                                fetch("/api/movimentacao/upload/corrcp/" + this.state.id, {
                                    method: "POST",
                                    headers: {
                                        "Authorization": "Basic " + btoa(localStorage.auth)
                                    },
                                    mode: "cors",
                                    body: formData2
                                })
                                .then(response3 => response3.json())
                                .then(responseJson3 => {

                                    if (responseJson3.msg === "success") {

                                        this.props.waitMsgHandler("");
                                        this.props.successMsgHandler("Movimentação financeira corrigida com sucesso.");

                                        let vecMovPrev = this.state.vecMovPrev;
                                        let vecMov = this.state.vecMov;

                                        if (vecMov.length > 1) {
                                            vecMovPrev.push(vecMov.shift());
                                        }

                                        let obj2 = {
                                            row: {
                                                id: vecMov[0].id,
                                                data: []
                                            },
                                            filtroAno: this.state.filtroAno,
                                            filtroMes: this.state.filtroMes,
                                            vecMovPrev: vecMovPrev,
                                            vecMov: vecMov
                                        };

                                        if (vecMov.length !== 0) obj2.row.id = vecMov[0].id;

                                        this.props.history.push({
                                            pathname: "/visualizarmovimentacao",
                                            state: obj2
                                        });

                                    }

                                });

                            }

                        });

                    }

                }

            });

        }

    }

    componentDidMount() {

        if (localStorage.roleMovimentacoes !== "corrigir") {
            window.location.href = "/home";
        }

        if (this.props.location.state === undefined) {
            window.location.href = "/movimentacoes";
        }

        let centro = this.props.location.state.centro;
        let centroId = this.props.location.state.centroId;
        let id = this.props.location.state.id;
        let banco = this.props.location.state.banco;
        let data = this.props.location.state.data;
        let historico = this.props.location.state.historico;
        let descricao = this.props.location.state.descricao;
        let valor = this.props.location.state.valor;
        let notaFiscal = this.props.location.state.notaFiscal;
        let comprovante = this.props.location.state.comprovante;
        let analiseContabil = this.props.location.state.analiseContabil;
        let ghg = this.props.location.state.ghg;
        let contaId = this.props.location.state.contaId;
        let status = this.props.location.state.status;
        let conta = this.props.location.state.conta;
        let codConta = this.props.location.state.codConta;
        let codMovimentacao = this.props.location.state.codMovimentacao;
        let cadastradoPor = this.props.location.state.cadastradoPor;
        let cadastradoPorNome = this.props.location.state.cadastradoPorNome;
        let edErrBanco = this.props.location.state.edErrBanco;
        let edErrData = this.props.location.state.edErrData;
        let edErrHistorico = this.props.location.state.edErrHistorico;
        let edErrDescricao = this.props.location.state.edErrDescricao;
        let edErrValor = this.props.location.state.edErrValor;
        let edErrNotaFiscal = this.props.location.state.edErrNotaFiscal;
        let edErrComprovante = this.props.location.state.edErrComprovante;
        let edErrAnaliseContabil = this.props.location.state.edErrAnaliseContabil;
        let edErrGhg = this.props.location.state.edErrGhg;
        let edErrContaId = this.props.location.state.edErrContaId;
        let corrBanco = this.props.location.state.corrBanco;
        let corrData = this.props.location.state.corrData;
        let corrHistorico = this.props.location.state.corrHistorico;
        let corrDescricao = this.props.location.state.corrDescricao;
        let corrValor = this.props.location.state.corrValor;
        let corrNotaFiscal = this.props.location.state.corrNotaFiscal;
        let corrComprovante = this.props.location.state.corrComprovante;
        let corrAnaliseContabil = this.props.location.state.corrAnaliseContabil;
        let corrGhg = this.props.location.state.corrGhg;
        let corrContaId = this.props.location.state.corrContaId;
        let corrConta = this.props.location.state.corrConta;
        let corrCodConta = this.props.location.state.corrCodConta;
        let corrCodMovimentacao = this.props.location.state.corrCodMovimentacao;
        let filtroAno = this.props.location.state.filtroAno;
        let filtroMes = this.props.location.state.filtroMes;
        let vecMovPrev = this.props.location.state.vecMovPrev;
        let vecMov = this.props.location.state.vecMov;

        this.setState({ centro: centro });
        this.setState({ centroId: centroId });
        this.setState({ id: id });
        this.setState({ banco: banco });
        this.setState({ data: data });
        this.setState({ historico: historico });
        this.setState({ descricao: descricao });
        this.setState({ valor: valor });
        this.setState({ notaFiscal: notaFiscal });
        this.setState({ comprovante: comprovante });
        this.setState({ analiseContabil: analiseContabil });
        this.setState({ ghg: ghg });
        this.setState({ contaId: contaId });
        this.setState({ status: status });
        this.setState({ cadastradoPor: cadastradoPor });
        this.setState({ cadastradoPorNome: cadastradoPorNome });
        this.setState({ edErrBanco: edErrBanco });
        this.setState({ edErrData: edErrData });
        this.setState({ edErrHistorico: edErrHistorico });
        this.setState({ edErrDescricao: edErrDescricao });
        this.setState({ edErrValor: edErrValor });
        this.setState({ edErrNotaFiscal: edErrNotaFiscal });
        this.setState({ edErrComprovante: edErrComprovante });
        this.setState({ edErrAnaliseContabil: edErrAnaliseContabil });
        this.setState({ edErrGhg: edErrGhg });
        this.setState({ edErrContaId: edErrContaId });
        this.setState({ filtroAno: filtroAno });
        this.setState({ filtroMes: filtroMes });
        this.setState({ vecMovPrev: vecMovPrev });
        this.setState({ vecMov: vecMov });

        if (edErrBanco === 0 || edErrBanco === 3 || edErrBanco === null) this.setState({ vBanco: banco });
        else this.setState({ vBanco: corrBanco });

        if (edErrData === 0 || edErrData === 3 || edErrData === null) this.setState({ vData: data });
        else this.setState({ vData: corrData });

        if (edErrHistorico === 0 || edErrHistorico === 3 || edErrHistorico === null) this.setState({ vHistorico: historico });
        else this.setState({ vHistorico: corrHistorico });

        if (edErrDescricao === 0 || edErrDescricao === 3 || edErrDescricao === null) this.setState({ vDescricao: descricao });
        else this.setState({ vDescricao: corrDescricao });

        if (edErrValor === 0 || edErrValor === 3 || edErrValor === null) this.setState({ vValor: valor });
        else this.setState({ vValor: corrValor });

        if (edErrNotaFiscal === 0 || edErrNotaFiscal === 3 || edErrNotaFiscal === null) this.setState({ vNotaFiscal: notaFiscal });
        else this.setState({ vNotaFiscal: corrNotaFiscal });

        if (edErrComprovante === 0 || edErrComprovante === 3 || edErrComprovante === null) this.setState({ vComprovante: comprovante });
        else this.setState({ vComprovante: corrComprovante });

        if (edErrAnaliseContabil === 0 || edErrAnaliseContabil === 3 || edErrAnaliseContabil === null) this.setState({ vAnaliseContabil: analiseContabil });
        else this.setState({ vAnaliseContabil: corrAnaliseContabil });

        if (edErrGhg === 0 || edErrGhg === 3 || edErrGhg === null) this.setState({ vGhg: ghg });
        else this.setState({ vGhg: corrGhg });

        if (edErrContaId === 0 || edErrContaId === 3 || edErrContaId === null) {
            this.setState({ vContaId: contaId });
            this.setState({ conta: conta });
            this.setState({ codConta: codConta });
            this.setState({ codMovimentacao: codMovimentacao });
        } else {
            this.setState({ vContaId: corrContaId });
            this.setState({ conta: corrConta });
            this.setState({ codConta: corrCodConta });
            this.setState({ codMovimentacao: corrCodMovimentacao });
        }

        if (edErrBanco === 3) {
            this.setState({ errBanco: edErrBanco });
        }

        if (edErrData === 3) {
            this.setState({ errData: edErrData });
        }

        if (edErrHistorico === 3) {
            this.setState({ errHistorico: edErrHistorico });
        }

        if (edErrDescricao === 3) {
            this.setState({ errDescricao: edErrDescricao });
        }

        if (edErrValor === 3) {
            this.setState({ errValor: edErrValor });
        }

        if (edErrNotaFiscal === 3) {
            this.setState({ errNotaFiscal: edErrNotaFiscal });
        }

        if (edErrComprovante === 3) {
            this.setState({ errComprovante: edErrComprovante });
        }

        if (edErrAnaliseContabil === 3) {
            this.setState({ errAnaliseContabil: edErrAnaliseContabil });
        }

        if (edErrGhg === 3) {
            this.setState({ errGhg: edErrGhg });
        }

        if (edErrContaId === 3) {
            this.setState({ errConta: edErrContaId });
        }

        fetch("/api/centro/banco/" + centroId, {
            method: "GET",
            headers: {
                "Content-type": "application/json",
                "Authorization": "Basic " + btoa(localStorage.auth)
            },
            mode: "cors"
        })
        .then(response => response.json())
        .then(responseJson => {

            this.setState({ bancos: responseJson });

            fetch("/api/conta/centro/" + centroId, {
                method: "GET",
                headers: {
                    "Content-type": "application/json",
                    "Authorization": "Basic " + btoa(localStorage.auth)
                },
                mode: "cors"
            })
            .then(response2 => response2.json())
            .then(responseJson2 => {

                this.setState({ contas: responseJson2 });

            });

        });

    }

    render() {
        return(
            <div>
                <h1 id="corrigir-movimentacao-title">
                    Corrigir Movimentação Financeira
                </h1><br />
                <p id="corrigir-movimentacao-centro">
                    <b>Centro: </b> { this.state.centro }
                </p><br /><br />
                { this.state.conf === false &&
                    <CorrigirMovimentacaoForm
                        data={ this.state.vData }
                        errData={ this.state.errData }
                        corrData={ this.state.corrData }
                        changeErrData={ this.changeErrData }
                        changeCorrData={ this.changeCorrData }
                        bancos={ this.state.bancos }
                        banco={ this.state.vBanco }
                        errBanco={ this.state.errBanco }
                        corrBanco={ this.state.corrBanco }
                        changeErrBanco={ this.changeErrBanco }
                        changeCorrBanco={ this.changeCorrBanco }
                        contas={ this.state.contas }
                        conta={ this.state.conta }
                        changeErrConta={ this.changeErrConta }
                        changeCorrConta={ this.changeCorrConta }
                        codConta={ this.state.codConta }
                        codMovimentacao={ this.state.codMovimentacao }
                        contaId={ this.state.vContaId }
                        errConta={ this.state.errConta }
                        corrConta={ this.state.corrConta }
                        corrCodConta={ this.state.corrCodConta }
                        corrCodMovimentacao={ this.state.corrCodMovimentacao }
                        historico={ this.state.vHistorico }
                        errHistorico={ this.state.errHistorico }
                        corrHistorico={ this.state.corrHistorico }
                        changeErrHistorico={ this.changeErrHistorico }
                        changeCorrHistorico={ this.changeCorrHistorico }
                        descricao={ this.state.vDescricao }
                        errDescricao={ this.state.errDescricao }
                        corrDescricao={ this.state.corrDescricao }
                        changeErrDescricao={ this.changeErrDescricao }
                        changeCorrDescricao={ this.changeCorrDescricao }
                        valor={ this.formatarValor(this.state.vValor) }
                        errValor={ this.state.errValor }
                        corrValor={ this.state.corrValor }
                        changeErrValor={ this.changeErrValor }
                        changeCorrValor={ this.changeCorrValor }
                        ghg={ this.state.vGhg }
                        errGhg={ this.state.errGhg }
                        corrGhg={ this.state.corrGhg }
                        changeErrGhg={ this.changeErrGhg }
                        changeCorrGhg={ this.changeCorrGhg }
                        notaFiscal={ this.state.vNotaFiscal }
                        errNotaFiscal={ this.state.errNotaFiscal }
                        corrNotaFiscal={ this.state.corrNotaFiscal }
                        changeErrNotaFiscal={ this.changeErrNotaFiscal }
                        changeCorrNotaFiscal={ this.changeCorrNotaFiscal }
                        comprovante={ this.state.vComprovante }
                        errComprovante={ this.state.errComprovante }
                        corrComprovante={ this.state.corrComprovante }
                        changeErrComprovante={ this.changeErrComprovante }
                        changeCorrComprovante={ this.changeCorrComprovante }
                        analiseContabil={ this.state.vAnaliseContabil }
                        errAnaliseContabil={ this.state.errAnaliseContabil }
                        corrAnaliseContabil={ this.state.corrAnaliseContabil }
                        changeErrAnaliseContabil={ this.changeErrAnaliseContabil }
                        changeCorrAnaliseContabil={ this.changeCorrAnaliseContabil }
                        corrigir={ this.corrigir }
                        cancelar={ this.cancelar } /> }
                { this.state.conf === true &&
                    <CorrigirMovimentacaoConf
                        data={ this.state.vData }
                        errData={ this.state.errData }
                        vErrData={ this.state.vErrData }
                        corrData={ this.state.corrData }
                        bancos={ this.state.bancos }
                        banco={ this.state.vBanco }
                        errBanco={ this.state.errBanco }
                        vErrBanco={ this.state.vErrBanco }
                        corrBanco={ this.state.corrBanco }
                        contas={ this.state.contas }
                        conta={ this.state.conta }
                        codConta={ this.state.codConta }
                        codMovimentacao={ this.state.codMovimentacao }
                        contaId={ this.state.vContaId }
                        errConta={ this.state.errConta }
                        vErrContaId={ this.state.vErrContaId }
                        corrConta={ this.state.corrConta }
                        corrCodConta={ this.state.corrCodConta }
                        corrCodMovimentacao={ this.state.corrCodMovimentacao }
                        historico={ this.state.vHistorico }
                        errHistorico={ this.state.errHistorico }
                        vErrHistorico={ this.state.vErrHistorico }
                        corrHistorico={ this.state.corrHistorico }
                        descricao={ this.state.vDescricao }
                        errDescricao={ this.state.errDescricao }
                        vErrDescricao={ this.state.vErrDescricao }
                        corrDescricao={ this.state.corrDescricao }
                        valor={ this.formatarValor(this.state.vValor) }
                        errValor={ this.state.errValor }
                        vErrValor={ this.state.vErrValor }
                        corrValor={ this.formatarValor(this.desformatarValor(this.state.corrValor)) }
                        ghg={ this.state.vGhg }
                        errGhg={ this.state.errGhg }
                        vErrGhg={ this.state.vErrGhg }
                        corrGhg={ this.state.corrGhg }
                        notaFiscal={ this.state.vNotaFiscal }
                        errNotaFiscal={ this.state.errNotaFiscal }
                        vErrNotaFiscal={ this.state.vErrNotaFiscal }
                        corrNotaFiscal={ this.state.corrNotaFiscal }
                        comprovante={ this.state.vComprovante }
                        errComprovante={ this.state.errComprovante }
                        vErrComprovante={ this.state.vErrComprovante }
                        corrComprovante={ this.state.corrComprovante }
                        analiseContabil={ this.state.vAnaliseContabil }
                        errAnaliseContabil={ this.state.errAnaliseContabil }
                        vErrAnaliseContabil={ this.state.vErrAnaliseContabil }
                        corrAnaliseContabil={ this.state.corrAnaliseContabil }
                        voltar={ this.voltar }
                        confirmar={ this.confirmar }
                        disabled={ this.state.disabled } /> }
            </div>
        );
    }

}

export default withRouter(CorrigirMovimentacao);

